import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "input", "typeSelect"]

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    // Focus input after animation
    requestAnimationFrame(() => {
      this.inputTarget.focus()
    })
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  selectType(event) {
    const btn = event.currentTarget
    const type = btn.dataset.type

    this.typeSelectTarget.value = type

    // Update active pill styling
    this.element.querySelectorAll("[data-search-pill]").forEach(pill => {
      pill.classList.remove("bg-red-600", "text-white")
      pill.classList.add("bg-gray-100", "dark:bg-gray-700", "text-gray-700", "dark:text-gray-300")
    })
    btn.classList.remove("bg-gray-100", "dark:bg-gray-700", "text-gray-700", "dark:text-gray-300")
    btn.classList.add("bg-red-600", "text-white")
  }
}
